import './output.css'; // Or the correct path to your output.css file
import { useState, useEffect } from 'react';
import axios from 'axios';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import CreatePagesFromBook from './pages/CreatePagesFromBook';
import CreateBook from './pages/CreateBook';
import EditBook from './pages/EditBook';
import EditPagePresets from './pages/EditPagePresets';
import LayoutTemplatesSettings from './pages/LayoutTemplatesSettings';
import DesignPresetsSettings from './pages/DesignPresetsSettings';
import BookList from './pages/BookList';
import HistoryPage from './pages/HistoryPage';
import LoginPage from './pages/LoginPage';
import Header from './components/Header';
import PreviewBook from './pages/PreviewBook';
import BulkEditorPagePresets from './pages/BulkEditorPagePresets';
import ReleaseBook from './pages/ReleaseBook';
import Releases from './pages/BookReleasesPage';
import CreateBookRelease from './pages/CreateBookRelease';
import EditBookRelease from './pages/EditBookRelease';
import BookTranslationsPage from './pages/BookTranslationsPage';
import BookCoverTextsPage from './pages/BookCoverTextsPage';
import VariantManagerPage from './pages/VariantManagerPage';
import VariantPagesPage from './pages/VariantPagesPage';
import VariantListPage from './pages/VariantListPage';
import VectorLayoutEditor from './pages/VectorLayoutEditor';

function App() {
  const [username, setUsername] = useState(null);

  useEffect(() => {
    axios.get('/api/whoami', { withCredentials: true }).then((res) => {
      if (res.data.logged_in) {
        setUsername(res.data.username);
      }
    });
  }, []);

  const handleLogout = () => {
    setUsername(null);
  };

  return (
    <BrowserRouter
      future={{
        v7_relativeSplatPath: true,
        v7_startTransition: true,
      }}
    >
      <div className="min-h-screen bg-yellow-100 p-6">
        {username && <Header username={username} onLogout={handleLogout} />}

        <Routes>
          {!username ? (
            <Route path="*" element={<LoginPage onLogin={setUsername} />} />
          ) : (
            <>
              <Route
                path="/login"
                element={<LoginPage onLogin={setUsername} />}
              />
              <Route path="/" element={<BookList />} />
              <Route path="/variants" element={<VariantListPage />} />
              <Route path="/books/new" element={<CreateBook />} />
              <Route path="/books/:bookId/edit" element={<EditBook />} />
              <Route
                path="/books/:bookId/variants/new"
                element={<VariantManagerPage />}
              />
              <Route
                path="/variants/:variantId/pages"
                element={<VariantPagesPage />}
              />
              <Route
                path="/create-pages-from-book"
                element={<CreatePagesFromBook />}
              />

              <Route
                path="/create-book-release/:bookId"
                element={<CreateBookRelease />}
              />
              <Route
                path="/book-releases/:releaseId/edit"
                element={<EditBookRelease />}
              />
              <Route path="/pages/:bookId" element={<BulkEditorPagePresets />} />
              <Route path="/preview-book/:bookId" element={<PreviewBook />} />
              <Route path="/release-book/:bookId" element={<ReleaseBook />} />
              <Route
                path="/book-translations/:book_id"
                element={<BookTranslationsPage />}
              />
              <Route
                path="/book/:bookId/translations"
                element={<BookTranslationsPage />}
              />
              <Route
                path="/book-cover-texts/:bookId"
                element={<BookCoverTextsPage />}
              />

              <Route path="/books" element={<BookList />} />
              <Route path="/edit/:id" element={<EditPagePresets />} />
              <Route path="/edit-preset/:id" element={<EditPagePresets />} />
              <Route
                path="/vector-layout/:bookId/:layoutId"
                element={<VectorLayoutEditor />}
              />
              <Route
                path="/design-presets"
                element={<LayoutTemplatesSettings />}
              />
              <Route path="/layout-templates" element={<LayoutTemplatesSettings />} />
              <Route path="/text-styles" element={<DesignPresetsSettings />} />
              <Route path="/history/:id" element={<HistoryPage />} />
              <Route path="/book-releases/:bookId" element={<Releases />} />
              <Route path="/book/:bookId/releases" element={<Releases />} />
            </>
          )}
        </Routes>
      </div>
    </BrowserRouter>
  );
}

export default App;
